import './DisabledAlert.scss';
import { Button } from 'antd';
import React from 'react';
import { SonarAlert } from '@ui/SonarAlert';
import { SonarText } from '@ui/text';
import { CHANGE_EVENT_PREFERENCES, LINKS } from '@sonar-software/sonar-ts-constants';
export const DisabledAlert = () => React.createElement(SonarAlert, { active: true, closable: true, message: React.createElement("div", { className: 'disabled-message' },
        React.createElement(SonarText, null, CHANGE_EVENT_PREFERENCES.DISABLED_TEXT),
        React.createElement(Button, { className: 'help-text-button', onClick: () => window.open(LINKS.PULSE_HELP_ARTICLE), type: 'primary' }, CHANGE_EVENT_PREFERENCES.READ_HELP_ARTICLE)), showIcon: true, type: 'error' });
